export { default as Img200 } from './processed/200/Victoria-S3.jpg';
export { default as Img400 } from './processed/400/Victoria-S3.jpg';
export { default as Imgthumb } from './processed/thumb/Victoria-S3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Victoria-S3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Victoria-S3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      232,
      53,
      23
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      61,
      14,
      6
    ],
    "_population": 15,
    "_hsl": [
      0.024242424242424242,
      0.8208955223880597,
      0.13137254901960785
    ]
  },
  "Muted": {
    "_rgb": [
      127,
      116,
      107
    ],
    "_population": 2722,
    "_hsl": [
      0.07499999999999997,
      0.08547008547008546,
      0.45882352941176474
    ]
  },
  "LightMuted": {
    "_rgb": [
      166,
      159,
      153
    ],
    "_population": 2299,
    "_hsl": [
      0.07692307692307696,
      0.06806282722513093,
      0.6254901960784314
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      75,
      63
    ],
    "_population": 2359,
    "_hsl": [
      0.1333333333333333,
      0.10638297872340427,
      0.27647058823529413
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Victoria-S3.js